var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.navigationHistory,
          expression: "navigationHistory"
        }
      ],
      class: _vm.bemBlock
    },
    [
      _c(
        "button",
        {
          class: [_vm.bemElement("btn"), "btn", "btn--back"],
          attrs: { type: "button" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClickBackButton()
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$msg("header.back", "header")) + "\n  ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }